export const MAX_NAME_LENGTH = 18;
export const MAX_TICKER_DISPLAY_LENGTH = 10;
